@switch (type) {
    @case (hintType.ICON) {
        <ap-action-icon id="hintIcon" (click)="openModal()" ariaLabel="Meer informatie" analyticsClick [key]="key" [elementType]="type">
            <ap-icon name="help" size="small"></ap-icon>
        </ap-action-icon>
    }
    @case (hintType.ICON_LINK) {
        <div class="ap-margin-top-3 ap-margin-bottom-3">
            <ap-icon-button-link
                id="hintIconLink"
                iconName="lightbulb"
                analyticsClick
                (click)="openModal()"
                [key]="key"
                [elementType]="type"
                >{{ getModalUrl() }}</ap-icon-button-link
            >
        </div>
    }
    @case (hintType.LINK) {
        <ap-button
            id="hintLink"
            [text]="true"
            ariaLabel="Hint link"
            analyticsClick
            (click)="openModal()"
            [key]="key"
            [elementType]="type"
            >{{ getModalUrl() }}</ap-button
        >
    }
}
